import React from 'react';
import { MarginProps } from '../../../theme/styledProps';
import { Wrapper } from '../Wrapper/Wrapper';
import { VisualPickerWrapper } from './VisualPicker.styles';
import { RadioBase } from '../Radio/RadioBase/RadioBase';
import { CheckboxBase } from '../Checkbox/Checkbox';

interface Props extends Omit<React.ComponentPropsWithoutRef<'input'>, 'size'>, MarginProps {
  variant?: 'radio' | 'checkbox';
}

export const VisualPickerContainer: React.FC<Props> = ({
  children,
  variant = 'radio',
  onChange,
  ...rest
}) => {
  const { disabled, checked } = rest;

  const InputComponent = variant === 'radio' ? RadioBase : CheckboxBase;

  return (
    <Wrapper {...rest}>
      <VisualPickerWrapper
        as="label"
        sizeVariant="medium"
        disabled={disabled}
        checked={checked}
        flexDirection="column"
      >
        <div>{children}</div>

        <InputComponent
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          hideFocus
          {...rest}
        />
      </VisualPickerWrapper>
    </Wrapper>
  );
};
